import React, { useState, useEffect } from 'react';
import './StaggeredTestimonials.scss';

const testimonials = [
  {
    quote: "Best cab service for airport transfers. The driver was waiting for me before my flight landed. Professional and punctual every single time.",
    author: "Rahul S.",
    role: "Frequent Business Traveler",
    avatar: "https://i.pravatar.cc/150?img=12"
  },
  {
    quote: "Very clean cars and professional behavior. Felt safe traveling solo at night. The live tracking feature gives me peace of mind.",
    author: "Ananya K.",
    role: "Regular Commuter",
    avatar: "https://i.pravatar.cc/150?img=32"
  },
  {
    quote: "Shirdi trip was effortless. No hidden tolls or parking fees. The driver knew all the best routes and was extremely courteous throughout the journey.",
    author: "Priya M.",
    role: "Weekend Traveler",
    avatar: "https://i.pravatar.cc/150?img=47"
  },
  {
    quote: "Transparent pricing is the best part. No haggling with drivers. What I see on the app is exactly what I pay. Highly recommend for daily commutes!",
    author: "Neha L.",
    role: "Daily Commuter",
    avatar: "https://i.pravatar.cc/150?img=24"
  },
  {
    quote: "Reliable and consistent. I always choose Pulpit. Their customer support is excellent and they actually care about rider experience.",
    author: "Rajesh G.",
    role: "Family Traveler",
    avatar: "https://i.pravatar.cc/150?img=58"
  }
];

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="testimonial-section" aria-label="Customer testimonials">
      <div className="testimonial-section__container">
        <header className="testimonial-section__header">
          <span className="testimonial-section__subtitle">Rider Stories</span>
          <h2 className="testimonial-section__title">What Our Riders Say</h2>
          <p className="testimonial-section__description">
            Real stories from our 10,000+ happy travelers who trust Pulpit Cabs for safe, reliable, and comfortable journeys across India.
          </p>
        </header>

        <div className="testimonial-section__content">
          <blockquote className="testimonial-section__quote">
            <p className="testimonial-section__text">
              {currentTestimonial.quote}
            </p>
            <footer className="testimonial-section__footer">
              <div className="testimonial-section__author-info">
                <img 
                  src={currentTestimonial.avatar} 
                  alt={currentTestimonial.author}
                  className="testimonial-section__avatar"
                  loading="lazy"
                />
                <div>
                  <cite className="testimonial-section__author">
                    {currentTestimonial.author}
                  </cite>
                  <div className="testimonial-section__role">
                    {currentTestimonial.role}
                  </div>
                </div>
              </div>
            </footer>
          </blockquote>

          <nav className="testimonial-section__navigation" aria-label="Testimonials navigation">
            <button
              onClick={prevTestimonial}
              className="testimonial-section__btn testimonial-section__btn--prev"
              aria-label="Previous testimonial"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <button
              onClick={nextTestimonial}
              className="testimonial-section__btn testimonial-section__btn--next"
              aria-label="Next testimonial"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </nav>

          <div className="testimonial-section__indicators">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`testimonial-section__indicator ${index === currentIndex ? 'testimonial-section__indicator--active' : ''}`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
